import { URLS } from "utils/constants";
import WorkshopTutorialPage from "pages/workshop/tutorial/workshop-tutorial-page";
import WorkshopPage from "pages/workshop/workshop-page";
import VehicleDetail from "pages/workshop/components/VehicleDetail";
import ServiceReport from "pages/workshop/components/ServiceReport";
import InventoryPage from "pages/workshop/inventory-page";
import WorkshopSupplierPage from "pages/workshop/workshop-supplier-page";
import PurchaseOrdersPage from "pages/workshop/purchase-orders/purchase-orders-page";
import PurchaseReceiptsPage from "pages/workshop/purchase-receipts/purchase-receipts-page";
import StockTransfersPage from "pages/workshop/stock-transfers-page";
import { InventoryProvider } from "pages/workshop/context/InventoryContext";
import { WorkshopSupplierProvider } from "pages/workshop/context/WorkshopSupplierContext";
import { PurchaseOrderProvider } from "pages/workshop/context/PurchaseOrderContext";
import { PurchaseReceiptProvider } from "pages/workshop/context/PurchaseReceiptContext";
import { StockTransferProvider } from "pages/workshop/context/StockTransferContext";
import { ATVProvider } from "pages/workshop/context/ATVContext";
import { ATVStatusProvider } from "pages/workshop/context/ATVStatusContext";
import { ServiceProvider } from "pages/workshop/context/ServiceContext";
import { ServiceTemplateProvider } from "pages/workshop/context/ServiceTemplateContext";
import { UserProvider } from "contexts/v1/masterData/UserContext";
import { WarehouseProvider } from "pages/workshop/context/WarehouseContext";
import { CategoryProvider } from "pages/workshop/context/CategoryContext";

export const workshopRoutes = [
  {
    path: URLS.v1.WORKSHOP,
    element: <WorkshopPage />,
  },
  {
    path: URLS.v1.WORKSHOP_TUTORIAL,
    element: <WorkshopTutorialPage />,
  },
  {
    path: `${URLS.v1.WORKSHOP}/vehicle/:id`,
    element: (
      <ATVProvider>
        <ATVStatusProvider>
          <UserProvider>
            <InventoryProvider>
              <ServiceTemplateProvider>
                <ServiceProvider>
                  <WarehouseProvider>
                    <VehicleDetail />
                  </WarehouseProvider>
                </ServiceProvider>
              </ServiceTemplateProvider>
            </InventoryProvider>
          </UserProvider>
        </ATVStatusProvider>
      </ATVProvider>
    ),
  },
  {
    path: URLS.v1.WORKSHOP_INVENTORY,
    element: (
      <InventoryProvider>
        <InventoryPage />
      </InventoryProvider>
    ),
  },
  {
    path: URLS.v1.WORKSHOP_SUPPLIER,
    element: (
      <WorkshopSupplierProvider>
        <WorkshopSupplierPage />
      </WorkshopSupplierProvider>
    ),
  },
  {
    path: URLS.v1.WORKSHOP_PURCHASE_ORDERS,
    element: (
      <PurchaseOrderProvider>
        <WarehouseProvider>
          <WorkshopSupplierProvider>
            <InventoryProvider>
              <PurchaseOrdersPage />
            </InventoryProvider>
          </WorkshopSupplierProvider>
        </WarehouseProvider>
      </PurchaseOrderProvider>
    ),
  },
  {
    path: URLS.v1.WORKSHOP_PURCHASE_RECEIPTS,
    element: (
      <PurchaseOrderProvider>
        <PurchaseReceiptProvider>
          <PurchaseReceiptsPage />
        </PurchaseReceiptProvider>
      </PurchaseOrderProvider>
    ),
  },
  {
    path: URLS.v1.WORKSHOP_SERVICE_REPORTS,
    element: (
      <ATVProvider>
        <WarehouseProvider>
          <CategoryProvider>
            <ServiceReport />
          </CategoryProvider>
        </WarehouseProvider>
      </ATVProvider>
    ),
  },
  {
    path: URLS.v1.WORKSHOP_STOCK_TRANSFERS,
    element: (
      <StockTransferProvider>
        <StockTransfersPage />
      </StockTransferProvider>
    ),
  },
];
